import { NormalizedOverstepPageData } from './types';
import { Maybe } from '@ids/types/utility';
import { IDSOverstepPageResponse } from '@ids/types/now-api';

export default function normalizeOverstepPageData(
    data: Maybe<IDSOverstepPageResponse>
): Maybe<NormalizedOverstepPageData> {
    if (!data || !data?.data?.length) {
        return null;
    }

    const overstepPage = data.data[0];

    return {
        title: overstepPage.title,
        contentText: overstepPage.contentText,
        cartCtaText: overstepPage.cartCtaText,
        startOverCtaText: overstepPage.startOverCtaText,
        backgroundImage: overstepPage.backgroundImage,
    };
}
